import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusBaoCaoDiemDanhActionTypeIds, IBusBaoCaoDiemDanhActionTypes } from "../../action-types/bus/IBusBaoCaoDiemDanhActionTypes";
import { IBusBaoCaoDiemDanhPageStateModel } from "../../page-state-model/bus/IBusBaoCaoDiemDanhPageState";

const initialState: IBusBaoCaoDiemDanhPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_baocao_diemdanhs: [],
	bus_tuyenduongs: []
}

export const busBaoCaoDiemDanhReducer = (state: IBusBaoCaoDiemDanhPageStateModel = initialState, action: IBusBaoCaoDiemDanhActionTypes): IBusBaoCaoDiemDanhPageStateModel => {
	switch (action.type) {
		case eBusBaoCaoDiemDanhActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusBaoCaoDiemDanhActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_baocao_diemdanhs: action.payload
			}
		case eBusBaoCaoDiemDanhActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_baocao_diemdanhs: []
			}
		case eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_START:
			return {
				...state
			}
		case eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_SUCCESS:
			return {
				...state,
				bus_tuyenduongs: action.payload
			}
		case eBusBaoCaoDiemDanhActionTypeIds.LOAD_TUYENDUONG_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_tuyenduongs: []
			}
		default:
			return state;
	}
}
